module.exports = __webpack_public_path__ + "static/media/project13.a913632a.png";